import React, { useCallback, useEffect, useState } from 'react';
import { ButtonColor } from '@lux/buttons';
import { Size } from '@lux/dialog';
import { ControlsAddXS } from '@lux/icons';
import { Preset, Text } from '@lux/text';
import { TitlePreset } from '@lux/title';
import { useCommercialMessage } from '@pegasus/commercial-messages';
import { Translate, TranslateScope } from '@pegasus/translation';
import { getCookie, setCookie } from '@browsing/utils';
import { tracker } from '../../tracking';
import { ZalandoPlus } from './assets/zalando-plus';
import * as S from './styles';
export var WELCOME_COOKIE = 'zl_plus_welcome_confirmed';
export var WelcomeDialog = function (_a) {
    var isPlatformJourney = _a.isPlatformJourney, platformJourneyDismissCookie = _a.platformJourneyDismissCookie;
    var _b = useState(false), isShown = _b[0], setShown = _b[1];
    var isCommercialMessageActive = useCommercialMessage();
    var onClose = useCallback(function () {
        setShown(false);
        setCookie(WELCOME_COOKIE, 'true', { expires: 365 * 5 });
        tracker.track('campaignOverview_earlyAccess_click');
    }, []);
    useEffect(function () {
        var isPlusWelcomeDismissed = getCookie(WELCOME_COOKIE) === 'true';
        var isPJDialogDismissed = platformJourneyDismissCookie && getCookie(platformJourneyDismissCookie) === 'true';
        var isPJCommunicationActive = isPlatformJourney && !isPJDialogDismissed;
        if (!isCommercialMessageActive && !isPJCommunicationActive && !isPlusWelcomeDismissed) {
            /**
             * Show the Plus Welcome dialog for the customer who have not seen it yet and
             *  - are active plus members
             *  - are not coming as PJ traffic
             */
            setShown(true);
            tracker.track('doi.email.campaignOverview_earlyAccess_view');
        }
    }, [isPlatformJourney, isCommercialMessageActive, platformJourneyDismissCookie]);
    return (React.createElement(TranslateScope, { path: "plus" },
        React.createElement(S.Dialog, { closeDialog: onClose, isShown: isShown, size: Size.L, sizeLg: Size.M },
            React.createElement(S.LogoContainer, null,
                React.createElement(ZalandoPlus, null),
                React.createElement(S.MarginlessTitle, { preset: TitlePreset.S },
                    React.createElement(Translate, { message: "welcome.zalandoPlus" }))),
            React.createElement(S.ImageContainer, null,
                React.createElement(S.Image, null),
                React.createElement(S.Badge, null)),
            React.createElement(S.ContentContainer, null,
                React.createElement("div", null,
                    React.createElement(S.Title, { preset: TitlePreset.S },
                        React.createElement(Translate, { message: "welcome.title" })),
                    React.createElement(Text, { preset: Preset.M },
                        React.createElement(Translate, { message: "welcome.description" })),
                    React.createElement(Text, { tag: S.List, preset: Preset.S }, ['A', 'B', 'C'].map(function (benefit) { return (React.createElement(S.LItem, { key: benefit },
                        React.createElement(ControlsAddXS, null),
                        React.createElement(Translate, { message: "welcome.benefits".concat(benefit) }))); }))),
                React.createElement(S.Button, { color: ButtonColor.dark, "data-testid": "plus-welcome-dialog-cta", fullWidth: true, onClick: onClose },
                    React.createElement(Translate, { message: "welcome.button" }))))));
};
